export class ArrayHelper {
  static addIfNotExists<T>(array: T[], item: T) {
    if (!array.includes(item)) {
      return [...array, item];
    }
    return array;
  }
}